import React from "react";
import Heading from "../../typography/Heading";
import Text from "../../typography/Text";
import "./ViewHeader.css";

export default function ViewHeader({
  title,
  description,
  actions,
  children,
  className = "",
  headingAs = "h2",
  size,
}) {
  return (
    <header className={["view-header", className].filter(Boolean).join(" ")}>
      <div className="view-header__body">
        {title && (
          <Heading as={headingAs} size={size ? size : "sm"}>
            {title}
          </Heading>
        )}
        {description && (
          <Text tone="secondary" size="sm">
            {description}
          </Text>
        )}
        {children}
      </div>
      {actions && <div className="view-header__actions">{actions}</div>}
    </header>
  );
}
